import { useEffect, useState } from 'react'
import './loader.scss'

export default function Loader() {
   const [loading, setLoading] = useState<boolean>(true)

   useEffect(() => {
      const timer = setTimeout(() => {
         setLoading(false)
      }, 10000)

      return () => {
         clearTimeout(timer)
      }
   }, [])

   const loader = <div className='loader'></div>

   const timedOut = <div></div>

   return <div className='loader-container'>
      {loading ? loader : timedOut}
   </div>
}
